import { supabase } from "@/lib/supabase";

/** En «ansatt» = aktiv bruker med kapasitet > 0. */
export function isExternalRole(role: string | null | undefined): boolean {
  return role === "external";
}

/** Henter id-ene til alle ansatte (aktiv bruker med kapasitet > 0). Eiere,
 *  ledelse og testbrukere har monthly_capacity_hours = 0 og ekskluderes,
 *  mens ekte ansatte (inkl. admin-roller med kapasitet) inkluderes. For å
 *  filtrere rapporter som ikke selv bærer rolle på radene. */
export async function fetchEmployeeUserIds(): Promise<Set<string>> {
  const { data, error } = await supabase
    .from("users")
    .select("id")
    .eq("is_active", true)
    .gt("monthly_capacity_hours", 0);
  if (error) throw error;
  return new Set((data ?? []).map((u) => u.id as string));
}
